<template>
  <b-container>
    <alarm-level-tab
      :edit-mode="editMode"
      :alarm-level="alarmLevel"
    />
    <b-row v-if="userPermission" align-h="end" class="mt-5 no-internal-print">
      <b-col v-if="editMode" cols="12" md="6" lg="auto" class="px-0 pr-md-1">
        <b-button @click="exitEditMode" block variant="secondary">
          {{ $t('actions.cancel') }}
        </b-button>
      </b-col>
      <b-col v-if="editMode" cols="12" md="6" lg="auto" class="mt-3 mt-md-0 px-0 pl-md-1">
        <b-button @click="confirmEdit" block variant="primary">
          {{ $t('actions.save') }}
        </b-button>
      </b-col>
      <b-col v-else cols="12" md="6" lg="auto" class="px-0">
        <b-button @click="enterEditMode" block variant="primary">
          {{ $t('actions.edit') }}
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import AlarmLevelService from '@/domain/services/installation/engineering/chromatography/alarmLevel';
import AlarmLevel from '@/domain/data/installation/engineering/chromatography/alarmLevelParameters/alarmLevel';
import AlarmLevelTab from '@/domain/components/installation/engineering/chromatography/alarmLevelParameters/AlarmLevelTab';

export default {
  components: {
    AlarmLevelTab,
  },
  data: () => ({
    alarmLevel: AlarmLevel,
    alarmLevelCopy: {},
    editMode: false,
  }),
  computed: {
    userPermission() {
      return this.$hasUserPermission('PER013');
    },
  },
  created() {
    this.getAlarmLevelsList();
  },
  methods: {
    getAlarmLevelsList() {
      const { assetModuleId } = this.$route.params;
      AlarmLevelService.getAlarmLevelsList(assetModuleId).then((resp) => {
        this.alarmLevel.response = resp;
      });
    },
    enterEditMode() {
      this.setAlarmLevelCopy();
      this.editMode = true;
    },
    setAlarmLevelCopy() {
      this.alarmLevelCopy = cloneDeep(this.alarmLevel.response);
    },
    exitEditMode() {
      this.$confirmMessage({
        code: 'MC006',
      }).accepted(() => {
        this.cancelEdit();
      });
    },
    cancelEdit() {
      this.alarmLevel.response = this.alarmLevelCopy;
      this.editMode = false;
    },
    setAlarmLevel() {
      const { assetModuleId } = this.$route.params;
      AlarmLevelService.setAlarmLevel(assetModuleId, this.alarmLevel.response).then(() => {
        this.getAlarmLevelsList();
        this.editMode = false;
        this.$pushAlert({ code: 'MS021' });
      });
    },
    confirmEdit() {
      this.$confirmMessage({
        code: 'MC011',
      }).accepted(() => {
        this.setAlarmLevel();
      });
    },
  },
};
</script>
